<template>
  <div>
    <el-drawer
      class="sideDrawer"
      :size="drawerSize"
      title="成本合同付款控制比例"
      destroy-on-close
      :visible.sync="show"
      :before-close="handleClose"
      :wrapperClosable="false"
      :close-on-press-escape="false"
    >
      <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div class="form-content" style="padding: 20px">
        <el-form ref="form" :model="form" label-width="160px" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="合同付款控制比例" prop="pay_ratio">
                <el-input type="number" placeholder="请输入合同付款控制比例" v-model="form.pay_ratio" min="0"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="handleSave" v-loading.fullscreen.lock="loading">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      drawerSize: '70%',
      tenantId: '-1',
      loading: false,
      form: { pay_ratio: 110 },
      rules: {
        pay_ratio: [
          {
            required: true,
            message: '请输入合同付款控制比例',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {},
  methods: {
    // 根据租户获取配置
    getDetail(refId) {
      this.form = { refId: refId, pay_ratio: 0, type_key: 'cost_pay_ratio_control' }
      let that = this
      that.$http.get('${portal}/portal/data_switch_config/getByKey?typeKey=cost_pay_ratio_control').then((resp) => {
        if (resp && resp.data) {
          this.form.pay_ratio = resp.data.pay_ratio || 110
          this.show = true
        }
      })
    },
    //关闭表单
    handleClose() {
      this.show = false
      this.$emit('close')
    },
    //提交表单
    handleSave() {
      this.loading = true
      this.form.pay_ratio = Number(this.form.pay_ratio)
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http
            .put('${portal}/portal/data_switch_config/update_default', this.form)
            .then((res) => {
              if (res.data.state) {
                this.loading = false
                this.$message.info('保存成功！')
              } else {
                this.loading = false
                this.$message.error('保存失败！')
              }
              this.handleClose()
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          this.loading = false
          return false
        }
      })
    }
  }
}
</script>

<style scoped></style>
